import React from 'react'
import PropTypes from 'prop-types'
import K8DigitalProgramCard from 'components/dashboard/K8DigitalProgramCard'

const ProductClasses = ({
  isK5Product,
  isMsProduct,
  classes,
  contentfulCourses,
  courseManager,
  currentProgramName,
  currentSite,
  displayTitle,
  entryId,
  firstTimeMS,
  headerDataTestId,
  index,
  internalTitle,
  onClassBlur,
  onClassFocus,
  onComponentClick,
  programSubheader,
  setFocus,
  staticLinksAvailable,
  classMenuButtonRefs,
  content = {},
}) => (
  <>
    {isK5Product && (
      <K8DigitalProgramCard
        classMenuButtonRefs={classMenuButtonRefs}
        classes={classes}
        content={content}
        contentfulCourses={contentfulCourses}
        courseManager={courseManager}
        currentProgramName={currentProgramName}
        currentSite={currentSite}
        displayTitle={displayTitle}
        entryId={entryId}
        firstTimeMS={firstTimeMS}
        headerDataTestId={headerDataTestId}
        index={index}
        internalTitle={internalTitle}
        isK5Product={true}
        onClassBlur={onClassBlur}
        onClassFocus={onClassFocus}
        onComponentClick={onComponentClick}
        programSubheader={programSubheader}
        setFocus={setFocus}
        staticLinksAvailable={staticLinksAvailable}
      />
    )}
    {isMsProduct && (
      <K8DigitalProgramCard
        classMenuButtonRefs={classMenuButtonRefs}
        classes={classes}
        content={content}
        contentfulCourses={contentfulCourses}
        courseManager={courseManager}
        currentProgramName={currentProgramName}
        currentSite={currentSite}
        displayTitle={displayTitle}
        entryId={entryId}
        firstTimeMS={firstTimeMS}
        headerDataTestId={headerDataTestId}
        index={index}
        internalTitle={internalTitle}
        isMsProduct={true}
        onClassBlur={onClassBlur}
        onClassFocus={onClassFocus}
        onComponentClick={onComponentClick}
        programSubheader={programSubheader}
        setFocus={setFocus}
        staticLinksAvailable={staticLinksAvailable}
      />
    )}
  </>
)

ProductClasses.propTypes = {
  classMenuButtonRefs: PropTypes.object,
  classes: PropTypes.array.isRequired,
  content: PropTypes.object,
  contentfulCourses: PropTypes.array.isRequired,
  courseManager: PropTypes.object,
  currentProgramName: PropTypes.string.isRequired,
  currentSite: PropTypes.shape({
    preferences: PropTypes.array,
  }),
  displayTitle: PropTypes.string.isRequired,
  entryId: PropTypes.string,
  firstTimeMS: PropTypes.bool,
  headerDataTestId: PropTypes.string,
  index: PropTypes.number,
  internalTitle: PropTypes.string.isRequired,
  isK5Product: PropTypes.bool.isRequired,
  isMsProduct: PropTypes.bool.isRequired,
  onClassBlur: PropTypes.func.isRequired,
  onClassFocus: PropTypes.func.isRequired,
  onComponentClick: PropTypes.func.isRequired,
  programSubheader: PropTypes.string,
  setFocus: PropTypes.func.isRequired,
  staticLinksAvailable: PropTypes.array.isRequired,
}

export default ProductClasses
